import { Button } from '@e2n/ui/v2';
import { EmptyCard } from '@/domain/mitarbeiter/features/rotationsplan/features/Plaene/components/EmptyCard';
import { RotationsplanCard } from '@/domain/mitarbeiter/features/rotationsplan/features/Plaene/components/RotationsplanCard';
import { Header } from '@/domain/mitarbeiter/features/rotationsplan/features/Plaene/Header';
import { useRotationsplanFeatureContext } from '@/domain/mitarbeiter/features/rotationsplan/features/shared/RotationsplanFeatureContext';
import { faPlus } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Link } from 'react-router-dom';

export function Uebersicht() {
  const { store } = useRotationsplanFeatureContext();
  const {
    data: {
      uebersicht: { rotationsplaene },
    },
  } = store;

  return (
    <div className="flex flex-col gap-6 items-start">
      <Header />
      <div
        key="uebersicht"
        className="w-full grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
        {rotationsplaene.length < 1 ? (
          <EmptyCard
            titleKey="domain.mitarbeiter.rotationsplan.rotationsplaene.keinPlan.title"
            subtitleKey="domain.mitarbeiter.rotationsplan.rotationsplaene.keinPlan.subtitle"
          />
        ) : (
          rotationsplaene.map((plan) => (
            <Link
              key={plan.id}
              className="min-w-0"
              to={`/mitarbeiter/rotationsplan/${plan.id}`}>
              <RotationsplanCard key={plan.id} rotationsplan={plan} />
            </Link>
          ))
        )}
      </div>
      <Button
        asChild
        iconOnly
        className="absolute md:hidden right-4 z-49 bottom-16 shadow-xl">
        <Link to={`/mitarbeiter/rotationsplaene/uebersicht/create`}>
          <FontAwesomeIcon icon={faPlus} />
        </Link>
      </Button>
    </div>
  );
}
